import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { TruthSection } from './components/TruthSection';
import { ProductReveal } from './components/ProductReveal';
import { Deliverables } from './components/Deliverables';
import { MechanismSection } from './components/MechanismSection';
import { ForWhom } from './components/ForWhom';
import { FAQ } from './components/FAQ';
import { PricingCTA } from './components/PricingCTA';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-primary text-text-primary font-sans selection:bg-accent-blue selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <TruthSection data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <Deliverables data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <ForWhom data-id="element-7" />
      <FAQ data-id="element-8" />
      <PricingCTA data-id="element-9" />
      <FinalClose data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}